<template>
    <div class="subscription-fqa-panel blue-block">
        <div class="panel-header">
            <h3 class="panel-title">Get a quote for your school</h3>
            <p style="margin-top: 15px">Fill out the information below and a quote will be automatically generated for you</p>
        </div>
        <div class="main-container"
        style="background-color: white; border-radius: 20px; padding: 20px;">
          <h4>Contact Information</h4>
          <div style="padding: 20px">
            <rt-input autofocus="true" v-model="model.name" placeholder="*Name"></rt-input>
            <rt-input v-model="model.school_name" placeholder="School Name"></rt-input>
            <rt-input v-model="model.email" placeholder="*Email"></rt-input>
          </div>
          <h4 style="margin-top: 20px;">Address</h4>
          <div style="padding: 20px">
            <rt-input v-model="model.address_line1" placeholder="Address Line #1"></rt-input>
            <rt-input v-model="model.address_line2" placeholder="Address Line #2"></rt-input>
            <rt-input v-model="model.address_city" placeholder="City"></rt-input>
            <rt-input v-model="model.address_state" placeholder="State"></rt-input>
            <rt-input v-model="model.address_zip" placeholder="Postal Code"></rt-input>
          </div>
          <div style="text-align: right; padding: 20px">
            <primary-button class="pull-right" @click="submitForm" :disabled="loading || downloaded">
              {{ loading ? "Downloading Quote..." : downloaded ? "Download complete" : "Submit and get quote" }}
            </primary-button>
          </div>
        </div>
    </div>
</template>

<script>

import RtPicture from '../../common/Picture.vue';
import PrimaryButton from '../../common/PrimaryButton.vue';
import RtTextarea from '../../common/RtTextarea.vue';
import RtInput from '../../common/Input.vue';
import {createQuote} from '../../../../common/api';
import _ from 'lodash';
import bridge from '../../../../common/bridge';

export default {
  name: 'SubscriptionQuoteForm',
  props: ['priceId'],
  components: {
    RtInput,
    RtTextarea,
    RtPicture,
    PrimaryButton
  },
  data: function() {
    return  {
      loading: false,
      downloaded: false,
      model: {
        name: '',
        email: '',
        school_name: '',
        address_line1: '',
        address_line2: '',
        address_city: '',
        address_state: '',
        address_zip: '',
      },
    }
  },
  methods: {
    mounted() {

    },
    async submitForm() {
      this.loading = true;
      const {name, email, school_name, address_line1, address_line2, address_city, address_zip, address_state} = this.model
      const country = _.result(bridge, 'session.country', 'US');
      try {
        await createQuote(name, email, school_name, address_line1, address_line2, address_zip, address_city, address_state, country, this.priceId)
        this.downloaded = true
      }
      finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-fqa-panel {
  padding: 128px 0;
  margin: 0 auto;

  .panel-header {
    padding-bottom: 56px;
    text-align: center;

    .panel-title {
      line-height: 1;
      font-family: "IBM Plex Serif",serif;
      font-weight: 700;
      font-size: 36px;
      color: #333;
    }

    p {
      font-size: 16px;
      font-family: Open Sans,sans-serif;
      font-weight: 400;
      line-height: 1.5;
      color: #000;
    }
  }
  .main-container {
    max-width: 770px !important;
    margin: 0 auto;
    border-radius: 22px;
    box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(191, 197, 208, 0.22);

    h4 {
      text-align: left;
    }

    .frequent-question-item {
      align-items: flex-start;
      background: #fff;
      padding: 0 32px 2px;
      margin-bottom: 16px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 16px;
      position: relative;
      .icon-circle {
        position: absolute;
        left: 101px;
        top: -8px;
      }
      .item-info-wrapper {
        flex: 1;
        margin-right: 10px;
        .question-info {
          max-width: 90%;
          padding: 32px 0;
          font-family: $title-font;
          font-weight: 700;
          font-size: 18px;
          color: $title-dark-grey;
          cursor: pointer;
          &.expanded {
            padding-bottom: 16px;
          }
        }
        .answer-info {
          padding-bottom: 32px;
          font-size: 16px;
          color: $title-grey;
        }
      }
      .btn-expand-item {
        min-width: 14px;
        margin-top: 40px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  @media (max-width: 767px) {
    padding: 50px 0;
  }
}
</style>
